import { ChangeEvent } from 'react';
import FormGroup from '../../../components/FormGroup';
import Input from '../../../components/Input';
import { GetErrorMessageByFieldNameType } from '../../../hooks/useErrors';

interface SendCodeViewInterface {
  getErrorMessageByFieldName: GetErrorMessageByFieldNameType;
  cpf: string;
  handleCpfChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export default function SendCodeView({
  getErrorMessageByFieldName,
  cpf,
  handleCpfChange,
}: SendCodeViewInterface) {
  return (
    <FormGroup error={getErrorMessageByFieldName('cpf')}>
      <label htmlFor="login">CPF</label>
      <Input
        placeholder="Informe seu CPF de acesso"
        value={cpf}
        onChange={handleCpfChange}
        autoComplete="new-password"
        error={getErrorMessageByFieldName('cpf')}
      />
    </FormGroup>
  );
}
